import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Tabs, Button, Modal } from "antd";
import { BulbOutlined, SnippetsOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { RetornoInformacoes } from "./components/retornoInformacoes";
import { SugestaoDetalhes } from "./components/detalhes";
import { SugestoesAnexos } from "./components/anexos";
import http from "../../../services/http";
const { Text } = Typography;

export const SugestoesDetalhesRetorno = () => {
  const { id_sugestao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dadosSugestao, setDadosSugestao] = useState(null);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (id_sugestao > 0) {
      carregarSugestao(id_sugestao);
    } else {
      navigate("/sugestoes");
    }
  }, [id_sugestao]);

  // CARREGAR SUGESTÃO
  const carregarSugestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/sugestoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setDadosSugestao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/sugestoes");
    }
    setLoading(false);
  };

  // ENVIAR RETORNO
  const enviarRetorno = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/sugestoes/enviar_retorno`, { id: id });
    if (api.statusCode === 200) {
      message.success("Sugestão enviada para avaliação!");
      navigate("/sugestoes");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: `Sugestão`,
      children: <SugestaoDetalhes idSugestao={id_sugestao} />,
    },
    {
      key: "2",
      label: `Anexos`,
      children: <SugestoesAnexos idSugestao={id_sugestao} status={dadosSugestao?.status} />,
    },
    dadosSugestao?.status === 1 && {
      key: "3",
      label: `Retorno de Informações`,
      children: <RetornoInformacoes idSugestao={id_sugestao} />,
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/sugestoes")} />
            <HeaderTitle
              title="Sugestões Detalhamento Inicial"
              subtitle={
                <Text italic>
                  <BulbOutlined /> {dadosSugestao && dadosSugestao.titulo}
                </Text>
              }
              icon={<SnippetsOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Tabs
                defaultActiveKey="1"
                items={items}
                tabBarExtraContent={{
                  right: dadosSugestao?.status === 1 && (
                    <Button
                      icon={<CheckCircleOutlined />}
                      onClick={() => {
                        modal.confirm({
                          title: "Deseja finalizar esta sugestão?",
                          okText: "Sim",
                          cancelText: "Cancelar",
                          onOk() {
                            enviarRetorno(id_sugestao);
                          },
                        });
                      }}>
                      Enviar
                    </Button>
                  ),
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
